import React from 'react';
import styles from './Sidebar.module.css';

function Sidebar({
  visible = true,
  menuItems = [],
  activeKey,
  onMenuClick,
  collapsed = false,
  onToggle
}) {
  if (!visible) return null;

  return (
    <div className={`${styles.sidebar} ${collapsed ? styles.collapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        <button className={styles.sidebarToggleBtn} onClick={onToggle}>
          {collapsed ? '→' : '←'}
        </button>
      </div>

      <div className={styles.sidebarMenu}>
        {menuItems.map(item => (
          <div
            key={item.key}
            className={`${styles.sidebarItem} ${activeKey === item.key ? styles.active : ''}`}
            onClick={() => onMenuClick?.(item)}
            title={collapsed ? item.label : ''}
          >
            <span className={styles.sidebarItemIcon}>
              {item.icon?.startsWith('#') ? (
                <svg className={styles.sidebarSvgIcon} aria-hidden="true">
                  <use xlinkHref={item.icon}></use>
                </svg>
              ) : (
                item.icon || '•'
              )}
            </span>

            {!collapsed && (
              <span className={styles.sidebarItemLabel}>{item.label}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Sidebar;